import { UiComponent } from '../../types/ui-component';
import React from 'react';
import { Separator } from '@cotera/client/v0/components/ui/separator';
import { Text } from '../text';

type DividerProps = {
  caption?: string;
} & UiComponent;

export const Divider: React.FC<DividerProps> = ({ className, caption }) => {
  if (caption) {
    return (
      <Separator className={className}>
        <Text.Caption>{caption}</Text.Caption>
      </Separator>
    );
  }
  return <Separator className={className} />;
};
